module.exports = __webpack_public_path__ + "908e4d2e/img/arrow-share-icon.00a12c29.svg";